import HashtagAvatar from "./hashtag-avatar";

export default HashtagAvatar;